import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { en } from './en'

export const DEFAULT_NS = 'en'

void i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  ns: [DEFAULT_NS],
  defaultNS: DEFAULT_NS,
  resources: { en: { [DEFAULT_NS]: en } },
  interpolation: { escapeValue: false },
})

export default i18n
